import { Callout } from '../../../../../../components/Callout';
import styles from '../SetupFarma.module.scss';

export const SetupFarmaCallout = () => (
  <div className={styles['setup-farma__main-config__footer']}>
    <Callout variant="warning" size="sm">
      As modificações realizadas até as 22h serão aplicadas na próxima integração de dados. Após esse horário, elas refletem na integração do dia seguinte.
    </Callout>
  </div>
);
